import React, { useState, useEffect } from 'react';
import { api } from '../utils/api';

const AddFirmPage = () => {
  const [categories, setCategories] = useState([]);
  const [cities] = useState(api.getCities());
  const [formData, setFormData] = useState({
    title: '',
    services: '',
    yetkiliAdi: '',
    yetkiliTelefon: '',
    yetkiliEmail: '',
    kategori: '',
    acikAdres: '',
    haritaKonum: '',
    kamuTelefon: '',
    kamuEmail: '',
    sehir: '',
    mahalle: '',
    sokak: '',
    apt: '',
    daire: ''
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const loadCategories = async () => {
      const cats = await api.getCategories();
      setCategories(cats);
    };
    loadCategories();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const result = await api.addFirm(formData);
      if (result.success) {
        alert(result.message || 'Firmanız başarıyla eklendi! Onaylandıktan sonra yayınlanacaktır.');
        setFormData({
          title: '',
          services: '',
          yetkiliAdi: '',
          yetkiliTelefon: '',
          yetkiliEmail: '',
          kategori: '',
          acikAdres: '',
          haritaKonum: '',
          kamuTelefon: '',
          kamuEmail: '',
          sehir: '',
          mahalle: '',
          sokak: '',
          apt: '',
          daire: ''
        });
      } else {
        alert(result.message || 'Firma eklenirken bir hata oluştu. Lütfen tekrar deneyin.');
      }
    } catch (error) {
      alert('Firma eklenirken bir hata oluştu. Lütfen tekrar deneyin.');
    }
    
    setLoading(false);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const headerStyle = {
    background: 'linear-gradient(135deg, var(--navy-blue) 0%, var(--baby-blue) 100%)',
    color: 'var(--white)',
    padding: '60px 0',
    textAlign: 'center'
  };

  const formStyle = {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '40px 20px'
  };

  const sectionStyle = {
    background: 'var(--white)',
    borderRadius: '12px',
    padding: '32px',
    marginBottom: '32px',
    boxShadow: '0 4px 15px rgba(0,0,0,0.1)'
  };

  const sectionTitleStyle = {
    fontSize: '20px',
    fontWeight: '600',
    color: 'var(--navy-blue)',
    marginBottom: '24px',
    fontFamily: 'Comfortaa, cursive',
    borderBottom: '2px solid var(--baby-blue)',
    paddingBottom: '8px'
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '20px'
  };

  return (
    <div>
      {/* Header */}
      <section style={headerStyle}>
        <div className="container">
          <h1 style={{ fontSize: '36px', marginBottom: '16px', fontFamily: 'Comfortaa, cursive' }}>
            Firma Ekle
          </h1>
          <p style={{ fontSize: '18px', opacity: 0.9 }}>
            Firmanızı rehberimize ekleyerek daha fazla müşteriye ulaşın
          </p>
        </div>
      </section>

      <div style={formStyle}>
        <form onSubmit={handleSubmit}>
          {/* Basic Information */}
          <div style={sectionStyle}>
            <h2 style={sectionTitleStyle}>Temel Bilgiler</h2>
            <div style={gridStyle}>
              <div className="form-group">
                <label className="form-label">Firma Adı *</label>
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  className="form-input"
                  required
                  placeholder="Firma adı"
                />
              </div>
              
              <div className="form-group">
                <label className="form-label">Kategori *</label>
                <select
                  name="kategori"
                  value={formData.kategori}
                  onChange={handleChange}
                  className="form-select"
                  required
                >
                  <option value="">Kategori Seçin</option>
                  {categories.map(cat => (
                    <option key={cat.id} value={cat.name}>{cat.name}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Hizmetler *</label>
              <textarea
                name="services"
                value={formData.services}
                onChange={handleChange}
                className="form-textarea"
                required
                placeholder="Firmanızın sunduğu hizmetleri detaylı olarak açıklayın"
              />
            </div>
          </div>

          {/* Contact Information */}
          <div style={sectionStyle}>
            <h2 style={sectionTitleStyle}>Yetkili Bilgileri (Gizli)</h2>
            <p style={{ fontSize: '14px', color: 'var(--gray-600)', marginBottom: '20px' }}>
              Bu bilgiler sadece onay sürecinde kullanılacak, kamuya açık olmayacaktır.
            </p>
            <div style={gridStyle}>
              <div className="form-group">
                <label className="form-label">Yetkili Adı Soyadı *</label>
                <input
                  type="text"
                  name="yetkiliAdi"
                  value={formData.yetkiliAdi}
                  onChange={handleChange}
                  className="form-input"
                  required
                  placeholder="Örn: Ahmet Yılmaz"
                />
              </div>
              
              <div className="form-group">
                <label className="form-label">Yetkili Telefonu *</label>
                <input
                  type="tel"
                  name="yetkiliTelefon"
                  value={formData.yetkiliTelefon}
                  onChange={handleChange}
                  className="form-input"
                  required
                  placeholder="Örn: 0532 123 45 67"
                />
              </div>
              
              <div className="form-group">
                <label className="form-label">Yetkili E-posta *</label>
                <input
                  type="email"
                  name="yetkiliEmail"
                  value={formData.yetkiliEmail}
                  onChange={handleChange}
                  className="form-input"
                  required
                  placeholder="Örn: ahmet@firma.com"
                />
              </div>
            </div>
          </div>

          {/* Public Contact */}
          <div style={sectionStyle}>
            <h2 style={sectionTitleStyle}>Kamuya Açık İletişim</h2>
            <div style={gridStyle}>
              <div className="form-group">
                <label className="form-label">Kamuya Açık Telefon *</label>
                <input
                  type="tel"
                  name="kamuTelefon"
                  value={formData.kamuTelefon}
                  onChange={handleChange}
                  className="form-input"
                  required
                  placeholder="Örn: 0212 555 01 01"
                />
              </div>
              
              <div className="form-group">
                <label className="form-label">Kamuya Açık E-posta</label>
                <input
                  type="email"
                  name="kamuEmail"
                  value={formData.kamuEmail}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="Örn: info@firma.com"
                />
              </div>
            </div>
          </div>

          {/* Address Information */}
          <div style={sectionStyle}>
            <h2 style={sectionTitleStyle}>Adres Bilgileri</h2>
            <div style={gridStyle}>
              <div className="form-group">
                <label className="form-label">Şehir *</label>
                <select
                  name="sehir"
                  value={formData.sehir}
                  onChange={handleChange}
                  className="form-select"
                  required
                >
                  <option value="">Şehir Seçin</option>
                  {cities.map(city => (
                    <option key={city} value={city}>{city}</option>
                  ))}
                </select>
              </div>
              
              <div className="form-group">
                <label className="form-label">Mahalle *</label>
                <input
                  type="text"
                  name="mahalle"
                  value={formData.mahalle}
                  onChange={handleChange}
                  className="form-input"
                  required
                  placeholder="Örn: Merkez Mahallesi"
                />
              </div>
              
              <div className="form-group">
                <label className="form-label">Sokak/Cadde *</label>
                <input
                  type="text"
                  name="sokak"
                  value={formData.sokak}
                  onChange={handleChange}
                  className="form-input"
                  required
                  placeholder="Örn: Atatürk Caddesi"
                />
              </div>
              
              <div className="form-group">
                <label className="form-label">Apartman/Bina No</label>
                <input
                  type="text"
                  name="apt"
                  value={formData.apt}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="Örn: 15"
                />
              </div>
              
              <div className="form-group">
                <label className="form-label">Daire/Bölüm</label>
                <input
                  type="text"
                  name="daire"
                  value={formData.daire}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="Örn: 3"
                />
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Açık Adres *</label>
              <textarea
                name="acikAdres"
                value={formData.acikAdres}
                onChange={handleChange}
                className="form-textarea"
                required
                placeholder="Detaylı adres bilgisi (Örn: Merkez Mahallesi, Atatürk Caddesi No:15, Beyoğlu/İstanbul)"
              />
            </div>

            <div className="form-group">
              <label className="form-label">Harita Konumu</label>
              <input
                type="text"
                name="haritaKonum"
                value={formData.haritaKonum}
                onChange={handleChange}
                className="form-input"
                placeholder="Google Maps linki veya koordinat bilgisi"
              />
            </div>
          </div>

          {/* Submit */}
          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <button 
              type="submit" 
              className="btn btn-primary"
              disabled={loading}
              style={{ 
                fontSize: '18px', 
                padding: '16px 48px',
                minWidth: '200px'
              }}
            >
              {loading ? 'Gönderiliyor...' : 'Firma Ekle'}
            </button>
            
            <p style={{ 
              fontSize: '14px', 
              color: 'var(--gray-600)', 
              marginTop: '16px',
              maxWidth: '500px',
              margin: '16px auto 0'
            }}>
              Firmanız eklendikten sonra inceleme sürecine alınacak ve 
              onaylandıktan sonra yayınlanacaktır. Bu süreç genellikle 1-2 iş günü sürmektedir.
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddFirmPage;